import { STORE_TOKEN } from "../actionTypes/auth";

export const storeToken = (refreshToken, idToken, ssoId) => ({
  type: STORE_TOKEN,
  payload: {
    refreshToken,
    idToken,
    ssoId
  }
});
